// extracted by mini-css-extract-plugin
module.exports = {"widthWrapper":"Footer_widthWrapper__n_rZW","companyInformation":"Footer_companyInformation__12_-S","accentedText":"Footer_accentedText__2ZM5e","column":"Footer_column__1XLw3"};